/**
 * Returns the default route for a given role after login.
 * Each role is redirected to the first page they have access to.
 */
export function getDefaultRouteForRole(role: string): string {
  switch (role) {
    case 'org_admin':
    case 'hr_manager':
      return '/tableau-de-bord' // Dashboard
    case 'finance':
      return '/paie' // Payroll (only page they can access)
    case 'manager':
      return '/espace-manager' // Manager dashboard
    case 'employee':
      return '/espace-personnel' // Employee self-service
    case 'super_admin_ataaba':
      return '/admin-ataaba' // Super admin console
    default:
      // '/' is the public landing page and redirects a signed-in user right
      // back here (see RootRoute) -- falling back to it for an unrecognized
      // role would loop forever.
      return '/tableau-de-bord'
  }
}
